import { render, staticRenderFns } from "./HeaderDropdownNotification.vue?vue&type=template&id=6f439212&scoped=true&"
import script from "./HeaderDropdownNotification.vue?vue&type=script&lang=js&"
export * from "./HeaderDropdownNotification.vue?vue&type=script&lang=js&"
import style0 from "./HeaderDropdownNotification.vue?vue&type=style&index=0&id=6f439212&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f439212",
  null
  
)

export default component.exports